import React from 'react';
import './SearchMatchesByPlayer.css';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { useSelector } from 'react-redux';

function SearchMatchesByPlayer({ onSelectPlayerHandler, onSelectOpponentHandler }) {
    const { playersList } = useSelector((state) => state.player);
    const { selectedPlayerForResults, selectedOpponentForResults } = useSelector((state) => state.match);

    const playersOptions = playersList?.map((player) => ({
        label: `${player.firstName} ${player.lastName}`,
        playerId: player.id,
    }));

    return (
        <div className='filter-bar'>
            <div className='filter-field'>
                <label className='filter-label'>שחקן</label>
                <Autocomplete
                    className='filter-autocomplete'
                    disablePortal
                    value={selectedPlayerForResults}
                    isOptionEqualToValue={(option, value) => option.playerId === value.playerId}
                    options={playersOptions}
                    onChange={(e, player) => onSelectPlayerHandler(e, player)}
                    renderInput={(params) => (
                        <TextField {...params} placeholder='בחר...' InputLabelProps={{ shrink: false }} />
                    )}
                    sx={{ '& .MuiAutocomplete-clearIndicator': { visibility: 'visible' } }}
                />
            </div>

            {selectedPlayerForResults && (
                <div className='filter-field filter-field--secondary'>
                    <label className='filter-label'>יריב</label>
                    <Autocomplete
                        className='filter-autocomplete'
                        disablePortal
                        value={selectedOpponentForResults}
                        isOptionEqualToValue={(option, value) => option.playerId === value.playerId}
                        options={playersOptions?.filter((p) => p.playerId !== selectedPlayerForResults.playerId)}
                        onChange={(e, player) => onSelectOpponentHandler(e, player)}
                        renderInput={(params) => (
                            <TextField {...params} placeholder='בחר...' InputLabelProps={{ shrink: false }} />
                        )}
                        sx={{ '& .MuiAutocomplete-clearIndicator': { visibility: 'visible' } }}
                    />
                </div>
            )}
        </div>
    );
}

export default SearchMatchesByPlayer;
